export const CommonQuestionBankTranslations = {
  QUESTION_BANK: {
    es: 'Listado de preguntas',
    en: 'Question bank',
    cat: 'Banc de preguntes',
    eus: 'Galdera bankua',
    pt: 'Banco de questões'
  },
  QUIZZES_COUNT_one: {
    es: 'En {{count}} test',
    en: 'In {{count}} quiz',
    cat: 'En {{count}} test',
    eus: 'Erantzun {{count}} testuan',
    pt: 'Em {{count}} teste'
  },
  QUIZZES_COUNT_other: {
    es: 'En {{count}} tests',
    en: 'In {{count}} quizzes',
    cat: 'En {{count}} tests',
    eus: 'Erantzun {{count}} testuetan',
    pt: 'Em {{count}} testes'
  },
  VALIDATE_QUESTION: {
    es: 'Validar pregunta',
    en: 'Validate question',
    cat: 'Validar pregunta',
    eus: 'Egiaztatu galdera',
    pt: 'Validar questão'
  },
  HIDE_QUESTION: {
    es: 'Ocultar pregunta',
    en: 'Hide question',
    cat: 'Ocultar pregunta',
    eus: 'Ezabatu galdera',
    pt: 'Ocultar questão'
  },
  DELETE_QUESTION: {
    es: 'Eliminar pregunta',
    en: 'Delete question',
    cat: 'Eliminar pregunta',
    eus: 'Ezabatu galdera',
    pt: 'Eliminar questão'
  },
  CANCEL: {
    es: 'Cancelar',
    en: 'Cancel',
    cat: 'Cancelar',
    eus: 'Ezabatu',
    pt: 'Cancelar'
  },
  PUBLISH: {
    es: 'Publicar',
    en: 'Publish',
    cat: 'Publicar',
    eus: 'Argitaratu',
    pt: 'Publicar'
  },
  REVIEW: {
    es: 'Revisar',
    en: 'Review',
    cat: 'Revisar',
    eus: 'Egiaztatu',
    pt: 'Revisar'
  },
  COURSE_SEARCH_PLACEHOLDER: {
    es: 'Cursos',
    en: 'Courses',
    cat: 'Cursos',
    eus: 'Ikastarok',
    pt: 'Cursos'
  },
  SECTION_SEARCH_PLACEHOLDER: {
    es: 'Temas',
    en: 'Themes',
    cat: 'Temes',
    eus: 'Gaiak',
    pt: 'Temas'
  },
  SEARCH_PLACEHOLDER: {
    es: 'Buscar pregunta',
    en: 'Search question',
    cat: 'Buscar pregunta',
    eus: 'Bilatu galdera',
    pt: 'Buscar questão'
  },
  FILTERS: {
    es: 'Filtros',
    en: 'Filters',
    cat: 'Filtres',
    eus: 'Eiragazkiak',
    pt: 'Filtros'
  },
  CREATED_BY_ME: {
    es: 'Creadas por mí',
    en: 'Created by me',
    cat: 'Creades per mi',
    eus: 'Nik sortua',
    pt: 'Criadas por mim'
  },
  MANUALLY_GENERATED: {
    es: 'Generadas a mano',
    en: 'Manually generated',
    cat: 'Generades a mà',
    eus: 'Eskuz sortua',
    pt: 'Geradas manualmente'
  },
  AI_GENERATED: {
    es: 'Generadas por IA',
    en: 'AI generated',
    cat: 'Generades per IA',
    eus: 'AI sortua',
    pt: 'Geradas por IA'
  },
  DELETE_QUESTION_CONFIRMATION: {
    es: '¿Estás seguro de querer eliminar esta pregunta? Se eliminará de todos los tests que la contienen.',
    en: 'Are you sure you want to delete this question? It will be removed from all tests that contain it.',
    cat: 'Estàs segur de voler eliminar aquesta pregunta? Se eliminarà de tots els tests que la contenen.',
    eus: 'Egiaztatu galdera? Ezabatuko da guztira dituen testuetan.',
    pt: 'Tem certeza que deseja eliminar esta questão? Se eliminará de todos os testes que a contêm.'
  },
  SHOW_QUESTION: {
    es: 'Mostrar pregunta',
    en: 'Show question',
    cat: 'Mostrar pregunta',
    eus: 'Erakutsi galdera',
    pt: 'Mostrar questão'
  },
  CLEAR_FILTERS: {
    es: 'Borrar filtros',
    en: 'Clear filters',
    cat: 'Netejar filtres',
    eus: 'Ezabatu filtrot',
    pt: 'Limpar filtros'
  },

  NO_QUESTIONS_ADDED: {
    es: 'Todavía no hay preguntas',
    en: 'No questions added',
    cat: 'Encara no hi ha preguntes',
    eus: 'Ez dituzu galdera bat gehitu',
    pt: 'Ainda não foram adicionadas questões'
  },

  NO_QUESTIONS_ADDED_DESCRIPTION: {
    es: 'Aquí aparecerán todas las preguntas que crees en tus test.',
    en: 'Here you will see all the questions you have created in your tests.',
    cat: 'Aquí veureu totes les preguntes que has creat en els teus tests.',
    eus: 'Zure testuetan sortutako galderak hemen ikusi dituzu.',
    pt: 'Aqui você verá todas as questões que criou nos seus testes.'
  }
};
